import { setToken } from "../../slices/authSlice";
import { lumiApi } from "../index";

export const authApi = lumiApi.injectEndpoints({
    endpoints: (build) => ({
        getUserProfile: build.query({
            query: () => ({
                url: '/profile/',
                method: 'GET'
            }),
            providesTags: ["UserProfile"],
            transformResponse(data) {
                localStorage.setItem("username", data?.username);
                return {
                    ...data,
                    isAuthorized: true,
                    workspaces: data?.workspaces,
                    defaultWorkspace: data?.default_workspace
                };
            },
        }),
        login: build.mutation({
            query: (body) => ({
                url: `/login`,
                method: "POST",
                body: JSON.stringify(body),
                headers: {
                    'Content-Type': 'application/json'
                }
            }),
            transformResponse(data) {
                localStorage.setItem("lumitoken", data.token);
                localStorage.setItem("loggedIn", true);
                return data
            },
            invalidatesTags: ["Projects"],
            async onQueryStarted(arg, { dispatch, queryFulfilled }) {
                try {
                    const { data } = await queryFulfilled;
                    dispatch(setToken(data.token));
                } catch (err) {
                    console.error("Login failed: ", err);
                }
            },
        }),
        createLongLivedToken: build.mutation({
            query: (body) => ({
                url: "login/long_token",
                body,
                method: "POST",
            }),
        }),
        validateToken: build.query({
            query: () => ({
                url: '/projects',
                method: 'GET'
            }),
            transformResponse: (response, meta) => {
                return {
                    isValid: meta?.response?.status === 200
                };
            },
            providesTags: ['TokenValidation']
        }),
        getFlags: build.query({
            query: () => ({
                url: '/profile/flags/',
                method: 'GET'
            }),
            transformResponse(data) {
                return data;
            },
            providesTags: ["Flags"],
        }),
    }),
});

export const {
    useGetUserProfileQuery,
    useLoginMutation,
    useValidateTokenQuery,
    useCreateLongLivedTokenMutation,
    useGetFlagsQuery,
} = authApi;
